const duration = 4000 // Duration of the animation in milliseconds
const updateInterval = 50 // How often to update counters (in milliseconds)

const countersWrapper = document.querySelectorAll('.counters-wrapper')

countersWrapper.forEach(countersWrapper => {
	const counters = countersWrapper.querySelectorAll('.counter')
	const countersWrapperDistance = countersWrapper.getBoundingClientRect().top

	const startCounters = () => {
		const startTime = Date.now()

		counters.forEach(counter => {
			const target = parseInt(counter.getAttribute('data-target'))
			const startValue = parseInt(counter.innerText)

			const updateCount = () => {
				const elapsedTime = Date.now() - startTime
				const progress = Math.min(elapsedTime / duration, 1)
				const currentCount = startValue + (target - startValue) * progress

				counter.innerText = Math.floor(currentCount)

				if (progress < 1) {
					setTimeout(updateCount, updateInterval)
				} else {
					counter.innerText = target // Ensure it ends exactly at target
				}
			}

			updateCount()
		})
	}

	let animationStarted = false
	window.addEventListener('scroll', e => {
		if (!animationStarted && window.pageYOffset + window.innerHeight - 50 >= countersWrapperDistance) {
			startCounters()
			animationStarted = true
		}
	})
})
